<div class="p-3">
  <h3 class="fs-24 text-muted">Assignment Details</h3>
  <!-- <div class="pb-2 text-end">
  <button class="btn btn-primary" (click)="location.back()">Go Back</button>
</div> -->
  <div class="row mb-3">
    <div class="col-md-9 col-12">
      <div class="card card-default">
        <div class="card-header">
          <h3 class="m-0 d-flex align-items-center justify-content-between">
            <div class="assignment d-flex">
              <span class="badge bg-primary" style="font-size: large">Ticket ID :
                {{ assignment && assignment.req_id ? assignment.req_id : "" }}
              </span>

              <div *ngIf="document_required_btn == 1" class="indicator blink_missing bg-warning mx-2"
                style="align-items: center; border-radius: 4px" [tooltip]="tooltipDocs" placement="right">
                <p class="px-2 py-2 fs-14 text-white fw-700" style="margin-bottom: 0">
                  Document Required
                </p>
              </div>

              <ng-template #tooltipDocs>
                <div class="docs-toltip text-start">
                  <ng-container *ngFor="let doc of authDocs; let i = index; let last = last">
                    {{ i + 1 }}. {{ doc.doc_name
                    }}<span *ngIf="!last"><br /></span>
                  </ng-container>
                </div>
              </ng-template>
            </div>
            <span *ngIf="assignment && assignment.status == 0" class="badge bg-warning pull-right">Pending</span>
            <span *ngIf="assignment && assignment.status == 1" class="badge bg-dark pull-right">Closed</span>
            <span *ngIf="assignment && assignment.status == 2" class="badge bg-primary pull-right">Re-Opened</span>
            <span *ngIf="assignment && assignment.status == 3" class="badge bg-info pull-right">Follow up</span>
            <span *ngIf="assignment && assignment.is_deleted == 1" class="badge bg-danger pull-right">Deleted</span>
            <span *ngIf="assignment && assignment.cus_dispute_id > 0" class="badge bg-info pull-right me-1"
              style="padding: 5px !important">Customer reported dispute</span>
          </h3>
          <br />
          <div class="row">
            <div class="col-md-5" *ngIf="phase_info && phase_info.admin_name">
              <h5>
                <i class="fa fa-user"></i> Current Account Manager :
                <strong>{{
                  phase_info && phase_info.admin_name
                  ? phase_info.admin_name
                  : ""
                  }}</strong>
              </h5>
            </div>
            <div class="col-md-7" *ngIf="phase_info && phase_info.phase_id">
              <h5 *ngIf="phase_info && phase_info.phase_id == 1">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>PHASE 0</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 2">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>PHASE 1</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 3">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>PHASE 2</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 4">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>PHASE 3</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 5">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>LOW POTENTIAL AUTOMATIC</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 6">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>LOW POTENTIAL MANUAL</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 7">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>RETENTION AUTOMATIC</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 8">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>RETENTION MANUAL</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 9">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>REVIVAL</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 10">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>ACTIVATION</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 11">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>REVIVAL</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 12">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>REVIVAL</strong>
              </h5>
              <h5 *ngIf="phase_info && phase_info.phase_id == 13">
                <i class="fa fa-level-up"></i> Current Business Phase :
                <strong>REVIVAL</strong>
              </h5>
            </div>
          </div>
        </div>
        <div class="card-body">
          <ng-template #empty>
            <div class="text-center border p-4 rounded">
              <span class="fa fa-exclamation-triangle fa-5x"></span>
              <p class="m-0 mt-2">Information not Available!</p>
            </div>
          </ng-template>

          <div *ngIf="assignment; else empty">
            <p *ngIf="assignment && assignment.is_deleted == 1" class="text-danger">
              This note has been deleted.
            </p>
            <!--Business Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.doctor_id > 0 && assignment.action_type != 'business_settlement_link_sent'">
              <div class="row">
                <div class="col-6">
                  <p class="text-bold mb-2 h4">Business Information</p>
                  <div>
                    <b>Business Name: </b>
                    {{ assignment.practice_name || "N.A." }}
                  </div>
                  <div>
                    <b>Business Email: </b>{{ assignment.practice_email || "N.A." }}
                  </div>
                  <div>
                    <b>Business Mobile: </b>{{
                    assignment.practice_mobile
                    ? (assignment.practice_mobile | countryPhone : assignment.country_id)
                    : "N.A."
                    }}
                    <br />
                  </div>
                </div>
                <div class="col-6">
                  <p class="text-bold mb-2 h4">Business Owner Information</p>
                  <b>Name: </b>
                  <a [routerLink]="
                      '/app/business/details/' + _shared.encodeId(assignment.doctor_id)
                    ">
                    {{ assignment.doctor_name || "N.A." }}
                  </a>
                  <br />
                  <b>Email: </b>{{ assignment.doctor_email || "N.A." }}<br />
                  <b>Mobile: </b>{{
                  assignment.doctor_mobile
                  ? (assignment.doctor_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}<br />
                </div>
              </div>
            </div>

            <!--Business User Info (raw data assignment uploaded by a business user)-->
            <div class="b mb-1 p-2 rounded note-item"
              *ngIf="assignment.action_type == 'wrongly_formatted_file_uploaded' && assignment.business_user_id > 0">
              <p class="text-bold mb-2 h4">Business User Information</p>
              <div>
                <b>Name: </b>
                <a [routerLink]="'/app/business/users/profile/' + _shared.encodeId(assignment.business_user_id)">
                  {{ assignment.business_user_name || "N.A." }}
                </a>
              </div>
              <div>
                <b>Email: </b>{{ assignment.business_user_email || "N.A." }}
              </div>
              <div>
                <b>Mobile: </b>{{
                assignment.business_user_mobile
                ? (assignment.business_user_mobile_country_code || "+1") + "-" + assignment.business_user_mobile
                : "N.A."
                }}
              </div>
              <div *ngIf="assignment.business_user_is_blocked == 1 || assignment.business_user_is_deleted == 1">
                <b>Status: </b>
                <span class="text-danger">{{ assignment.business_user_is_deleted == 1 ? "Deleted" : "Blocked" }}</span>
              </div>
            </div>

            <!--Patient Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="
                assignment.split_token != 0 && assignment.split_token != null && assignment.action_type != 'business_settlement_link_sent'
              ">
              <p class="text-bold mb-2 h4">
                {{ assignment.is_arv2 == 1 ? "CredeeBill" : "" }} Proposal
                Information
              </p>
              <div class="row">
                <div class="col">
                  <b>Account ID: </b>
                  <a [routerLink]="
                      '/app/debt-recovery/details/' + _shared.encodeId(assignment.split_req_id)
                    ">
                    {{
                    assignment.account_id
                    ? assignment.account_id
                    : "Go to Details"
                    }}
                  </a>
                  <br />
                  <b>Name: </b>
                  {{ assignment.patient_title }}
                  {{ assignment.patient_first_name }}
                  {{ assignment.patient_last_name }}
                  <br />
                  <b>Email: </b>{{ assignment.patient_email || "N.A." }}<br />
                   <span *ngIf="assignment.contact_type_name"><b>Contact Type: </b>{{ assignment.contact_type_name }}<br /></span>
                </div>
                <div class="col">
                  <b>Mobile: </b>{{
                  assignment.patient_mobile
                  ? (assignment.patient_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
               
                    <ng-container *ngIf="assignment.contact_result == 58 || assignment.contact_result == 59 || assignment.contact_result == 60">
                    <br />
                    <b>Dialed Number: </b>{{ assignment.assigned_contact_number ? (assignment.assigned_contact_number | countryPhone : assignment.country_id) : "N.A." }}
                    </ng-container>

                    <!-- E-Oscar Dispute ticket only; the dates are stored without time, so format in UTC to avoid a day shift -->
                    <ng-container *ngIf="assignment.action_type == 'e_oscar_dispute'">
                    <br />
                    <b>Received Date: </b>{{ assignment.eoscar_received_date ? (assignment.eoscar_received_date | date: 'MM/dd/yyyy' : 'UTC') : "N.A." }}
                    <br />
                    <b>Response Date: </b>{{ assignment.eoscar_response_date ? (assignment.eoscar_response_date | date: 'MM/dd/yyyy' : 'UTC') : "N.A." }}
                    </ng-container>

                </div>
              </div>
            </div>

            <!--Contract Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.contract_id > 0 && assignment.financed_amount > 0">
              <p class="text-bold mb-2 h4">Contract Information</p>
              <div class="row">
                <div class="col">
                  <b>Account ID: </b>
                  <a [routerLink]="
                      '/app/contracts/details/' + _shared.encodeId(assignment.contract_id)
                    ">{{ assignment.account_id }}</a>
                  <br />
                  <b>Next Payment Date: </b>
                  {{
                  (assignment.next_payment_date
                  | date : "MM/dd/yyyy" : "+0000") || "N.A."
                  }}
                  <br />
                  <b>Status: </b>
                  <span [ngClass]="{
                      'text-success':
                        assignment.pf_status < 3 || assignment.pf_status == 4,
                      'text-warning': assignment.pf_status == 3,
                      'text-danger': assignment.pf_status == 5
                    }">
                    <span *ngIf="assignment.pf_status < 3">Active</span>
                    <span *ngIf="assignment.pf_status == 3">Overdue</span>
                    <span *ngIf="assignment.pf_status == 4">Completed</span>
                    <span *ngIf="assignment.pf_status == 5">Canceled</span>
                  </span>
                </div>
                <div class="col">
                  <b>Financed Amount: </b> {{ assignment.wp_display_logo
                  }}{{
                  (assignment.financed_amount | currencyFormat) || "N.A."
                  }}
                  <br />
                  <b>Number of Missing Payments: </b>
                  {{ assignment.missing_payments }}
                  <br />
                    <b>Dialed Number: </b>{{ assignment.assigned_contact_number ? (assignment.assigned_contact_number | countryPhone : assignment.country_id) : "N.A." }}

                  <div *ngIf="assignment.request_type_name">
                    <b>Approval Needed for:</b>
                    {{ assignment.request_type_name || "N.A." }}
                    <!-- <span *ngIf="assignment.is_approved == 0"></span> -->
                    <span *ngIf="assignment.is_approved == 1" tooltip="Approved">
                      <i class="fa fa-check text-success"></i>
                    </span>
                    <span *ngIf="assignment.is_approved == 2" tooltip="Rejected">
                      <i class="fa fa-close text-danger"></i>
                    </span>
                    <br />
                    <a href="javascript:void(0)" (click)="approveRejectModal(1)" class="btn btn-primary btn-xs rounded"
                      *ngIf="
                        assignment.is_approved == 0 ||
                        assignment.is_approved == 2
                      ">
                      <small>Approve</small>
                    </a>
                    <a href="javascript:void(0)" (click)="approveRejectModal(2)"
                      class="btn btn-danger btn-xs rounded ms-2" *ngIf="
                        assignment.is_approved == 0 ||
                        assignment.is_approved == 1
                      ">
                      <small>Reject</small>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.action_type === 'internal_account_action_flow'">
              <p class="text-bold mb-2 h4">Approval Information</p>
              <b>Approval Needed for:</b> {{ assignment.is_approved == 2 ? (assignment.action_value === 'Charged off' ? 'Charge off' : assignment.action_value === 'Written off' ? 'Write off' : assignment.action_value === 'Canceled' ? 'Cancellation' : assignment.action_value) : (assignment.action_value || 'N.A.') }}
              <span *ngIf="assignment.is_approved == 1" ><i class="bi bi-check"></i></span>
              <span *ngIf="assignment.is_approved == 2" ><i class="bi bi-x"></i></span>
              <span *ngIf="assignment.is_approved == 1" tooltip="Approved">
                <i class="fa fa-check text-success"></i>
              </span>
              <span *ngIf="assignment.is_approved == 2" tooltip="Rejected">
                <i class="fa fa-close text-danger"></i>
              </span>
              <br /><br>
              <div *ngIf="assignment.is_approved == 0">
              <a href="javascript:void(0)" (click)="approveRejectModal(1)" class="btn btn-primary btn-xs rounded"
                *ngIf="assignment.is_approved == 0 || assignment.is_approved == 1">
                <small>Approve</small>
              </a>
              <a href="javascript:void(0)" (click)="approveRejectModal(2)" class="btn btn-danger btn-xs rounded ms-2"
                *ngIf="assignment.is_approved == 0 || assignment.is_approved == 1">
                <small>Reject</small>
              </a>
              </div>
            </div>

            <!--CB and PP Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.pp_id > 0">
              <p class="text-bold mb-2 h4">Payment Information</p>
              <div class="row">
                <div class="col">
                  <b>Payment ID: </b>
                  <a *ngIf="assignment.is_ar == 0" [routerLink]="
                      '/app//payment-processing/' + assignment.pp_id
                    ">{{
                    assignment.payment_process_code
                    ? assignment.payment_process_code
                    : " Go to Details"
                    }}</a>
                  <a *ngIf="assignment.is_ar == 1" [routerLink]="
                      '/app/accounts-receivable/' + assignment.pp_id
                    ">{{
                    assignment.payment_process_code
                    ? assignment.payment_process_code
                    : " Go to Details"
                    }}</a>
                  <br />
                  <b>Business Name: </b><a [routerLink]="
                      '/app/business/details/' + _shared.encodeId(assignment.pp_doctor_id)
                    ">
                    {{
                    assignment.pp_practice_name
                    ? assignment.pp_practice_name
                    : assignment.pp_doctor_name || "N.A."
                    }}
                  </a>
                  <br />
                  <b>Business Email: </b>
                  {{
                  assignment.pp_practice_email
                  ? assignment.pp_practice_email
                  : assignment.pp_doctor_email
                  ? assignment.pp_doctor_email
                  : "N.A."
                  }}
                  <br />
                  <b>Business Mobile: </b>
                  {{
                  assignment.pp_practice_mobile
                  ? (assignment.pp_practice_mobile | countryPhone : assignment.country_id)
                  : assignment.pp_doctor_mobile
                  ? (assignment.pp_doctor_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                </div>
                <div class="col">
                  <b>Customer Name: </b>
                  {{
                  assignment.pp_patient_name
                  ? assignment.pp_patient_name
                  : "N.A."
                  }}

                  <br />
                  <b>Customer Email: </b>
                  {{
                  assignment.pp_patient_email
                  ? assignment.pp_patient_email
                  : "N.A."
                  }}
                  <br />
                  <b>Customer Mobile: </b>
                  {{
                  assignment.pp_patient_mobile
                  ? (assignment.pp_patient_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                </div>
              </div>
            </div>

            <!--Partner Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.partner_id > 0">
              <p class="text-bold mb-2 h4">Partner Information</p>
              <div class="row">
                <div class="col">
                  <b>Name: </b>
                  <a [routerLink]="
                      '/app/partners/profile/' + assignment.partner_id
                    ">{{ assignment.partner_title }}
                    {{ assignment.partner_name || "N.A." }}</a>
                  <br />
                  <b>Email: </b> {{ assignment.partner_email || "N.A." }}<br />
                  <div *ngIf="assignment && assignment.call_req_doc_mobile">
                    <strong>Request Generated For: </strong>{{
                    assignment.call_req_doc_mobile
                    ? assignment.call_req_doc_mobile
                    : "N.A."
                    }}
                  </div>
                </div>
                <div class="col">
                  <b>Phone: </b>{{
                  assignment.partner_mobile
                  ? (assignment.partner_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                  <br />
                  <span *ngIf="assignment.call_req_date"><b>Requested Date:</b>
                    {{
                    (assignment.call_req_date
                    | date : "MM/dd/yyyy" : "+0000") || "N.A."
                    }}</span><br />
                  <span *ngIf="assignment.call_req_time"><b>Requested Time:</b>{{
                    (assignment.call_req_time &&
                    assignment.call_req_time.substring(0, 5)) ||
                    "N.A."
                    }}
                    ({{ timezoneName }})</span><br />
                  <span *ngIf="assignment.call_req_dt"><b>Localtime : </b>{{
                    assignment.call_req_dt
                    | date : "MM/dd/yyyy hh:mm a" : timezone
                    }}</span>
                </div>
              </div>
            </div>

            <!--Customer Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.patient_id > 0">
              <p class="text-bold mb-2 h4">Customer Information</p>
              <div class="row">
                <div class="col">
                  <b>Name: </b>
                  <a [routerLink]="
                      '/app/customers/profile/' + _shared.encodeId(assignment.patient_id)
                    ">
                    {{ assignment.patient_title }}
                    {{ assignment.patient_first_name }}
                    {{ assignment.patient_last_name }}
                  </a>
                  <br />
                  <b>Email: </b> {{ assignment.patient_email }}<br />
                  <div *ngIf="assignment && assignment.call_req_doc_mobile">
                    <strong>Request Generated For: </strong>{{
                    assignment.call_req_doc_mobile
                    ? assignment.call_req_doc_mobile
                    : "N.A."
                    }}
                  </div>
                </div>
                <div class="col">
                  <b>Mobile: </b>{{
                  assignment.patient_mobile
                  ? (assignment.patient_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                  <br />
                  <span *ngIf="assignment.call_req_date"><b>Requested Date:</b>
                    {{
                    (assignment.call_req_date
                    | date : "MM/dd/yyyy" : "+0000") || "N.A."
                    }}</span><br />
                  <span *ngIf="assignment.call_req_time"><b>Requested Time:</b>{{
                    (assignment.call_req_time &&
                    assignment.call_req_time.substring(0, 5)) ||
                    "N.A."
                    }}
                    ({{ timezoneName }})</span><br />
                  <span *ngIf="assignment.call_req_dt"><b>Localtime : </b>{{
                    assignment.call_req_dt
                    | date : "MM/dd/yyyy hh:mm a" : timezone
                    }}</span>
                </div>
              </div>
            </div>

            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.action_type == 'bankruptcy'">
              <p class="text-bold mb-2 h4">Customer Information</p>
              <div class="row">
                <div class="col">
                  <b>Name: </b>
                  <a [routerLink]="'/app/debt-recovery/details/'+_shared.encodeId(assignment.split_req_id)">
                    {{assignment.bankruptcy_first_name}} {{assignment.bankruptcy_last_name}}
                  </a>
                  <br>
                  <b>Email: </b> {{assignment.bankruptcy_email}}<br />
                </div>
                <div class="col">
                  <b>Mobile: </b>{{assignment.bankruptcy_mobile ? (assignment.bankruptcy_mobile | countryPhone : assignment.country_id) : 'N.A.'}}
                </div>
              </div>
            </div>

            <!--Business Settlement Link Info-->
            <div class="b mb-1 p-2 rounded note-item"
              *ngIf="assignment.action_type == 'business_settlement_link_sent'">
              <p class="text-bold mb-2 h4">Business Settlement Link</p>
              <div class="row">
                <div class="col">
                  <b>Amount Settled At: </b>
                  {{ formMetaDataInfo.settlement_amount
                    ? (assignment.wp_display_logo || '$') + (formMetaDataInfo.settlement_amount | currencyFormat)
                    : 'N.A.' }}
                  <br />
                  <b>Recuvery Share: </b>
                  {{ formMetaDataInfo.fee_amount || formMetaDataInfo.recuvery_share
                    ? (assignment.wp_display_logo || '$') + ((formMetaDataInfo.fee_amount || formMetaDataInfo.recuvery_share) | currencyFormat)
                    : 'N.A.' }}
                  <br />
                  <!-- <b>Business Email: </b>
                  {{ assignment.business_email || assignment.practice_email || 'N.A.' }}
                  <br />
                  <b>Alternate Email: </b>
                  {{ formMetaDataInfo.alternate_email || 'N.A.' }} -->
                </div>
                <div class="col">
                  <b>Payment Link Sent: </b>
                  <span *ngIf="formMetaDataInfo.email_sent_status == 1 || formMetaDataInfo.is_payment_link_sent == 1"
                    class="badge bg-success">Sent</span>
                  <span *ngIf="!(formMetaDataInfo.email_sent_status == 1 || formMetaDataInfo.is_payment_link_sent == 1)"
                    class="badge bg-warning">Pending</span>
                  <br />
                  <b>Sent Date/Time: </b>
                  {{
                    (assignment.payment_link_sent_at || assignment.payment_link_sent_date || assignment.date_added)
                      | date : 'MM/dd/yyyy hh:mm a' : timezone
                  }}
                  ({{ timezoneName }})
                  <br />
                  <b>Assigned To: </b>
                  {{ assignment.assigned_admin_name || 'Not Assigned Yet' }}
                  <br />
                  <span *ngIf="assignment.split_req_id">
                    <b>Account ID: </b>
                    <a [routerLink]="'/app/debt-recovery/details/' + _shared.encodeId(assignment.split_req_id)">
                      {{assignment.account_id}}
                    </a>
                  </span>
                </div>
              </div>
            </div>

            <!--Callback request Info-->
            <div *ngIf="
                formMetaDataInfo &&
                assignment.action_type != 'preapproval_business_leads' && assignment.action_type != 'business_settlement_link_sent'
              " class="b mb-1 p-2 rounded note-item">
              <p class="text-bold mb-2 h4">Callback Form Information</p>
              <div class="row">
                <div class="col">
                  <b>Name: </b> {{ formMetaDataInfo.name || "N.A." }} <br />
                  <b>Email: </b>{{ formMetaDataInfo.email || "N.A." }}<br />

                  <span *ngIf="formMetaDataInfo.unpaid_accounts_range">
                    <b>Number of Unpaid Accounts: </b>{{ formMetaDataInfo.unpaid_accounts_range }}<br />
                  </span>

                  <b>Request: </b>
                  {{
                  assignment.request_type_name
                  ? assignment.request_type_name
                  : assignment.action_value
                  ? assignment.action_value
                  : "N.A."
                  }}
                  <br />
                  <b>User Status: </b>
                  <span *ngIf="assignment.user_status == 1; else registeredTemp">Registered</span>
                  <br />
                  <ng-template #registeredTemp><span>Unregistered</span></ng-template>
                  <br />
                </div>
                <div class="col">
                  <b>Mobile: </b>{{
                  formMetaDataInfo.mobile
                  ? (formMetaDataInfo.mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                  <br />
                  <span *ngIf="assignment.call_req_date"><b>Requested Date:</b>
                    {{
                    (assignment.call_req_date | date : "MM/dd/yyyy") || "N.A."
                    }}</span><br />
                  <span *ngIf="assignment.call_req_time">
                    <b class="fs-14 fw-700">Requested Time:</b>{{
                    (assignment.call_req_dt &&
                    (assignment.call_req_dt
                    | date : "hh:mm a" : timezone)) ||
                    "-"
                    }}
                    ({{ timezoneName }})</span><br />
                  <span *ngIf="assignment.call_req_dt"><b>Localtime : </b>{{
                    assignment.call_req_dt
                    | date : "MM/dd/yyyy hh:mm a" : timezone
                    }}</span><br />
                  <span *ngIf="assignment.request_source == 1">
                    <b>Requested From:</b> Application
                  </span>
                  <span *ngIf="assignment.request_source == 2"><b>Requested From:</b> Website</span>
                  <br />
                </div>
              </div>
              <div *ngIf="formMetaDataInfo.comments" class="row">
                <div class="col-12">
                  <b>What's on your mind: </b>{{ formMetaDataInfo.comments }}
                </div>
              </div>
              <div *ngIf="
                  formMetaDataInfo.parent_id && formMetaDataInfo.parent_id != ''
                " class="row">
                <div class="col">
                  <p class="text-bold mb-2 h4">
                    Associated Business Information
                  </p>
                  <b>Business Owner Name: </b>
                  {{ formMetaDataInfo.parent_name || "N.A." }} <br />
                  <b>Business Owner Email: </b>{{ formMetaDataInfo.parent_email || "N.A." }}
                </div>
              </div>
            </div>

            <!--Wordpress Enquiry Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.wp_query_id && assignment.wp_query_id > 0">
              <p class="text-bold mb-2 h4">Inquiry Information</p>
              <div class="row">
                <div class="col">
                  <b>Name: </b> {{ assignment.wp_name || "N.A." }} <br />
                  <b>Email: </b>{{ assignment.wp_email || "N.A." }}<br />
                  <b>Address: </b>{{ assignment.wp_address ? assignment.wp_address : "N.A." }}
                  <br />
                  <b>State: </b>
                  {{
                  assignment.wp_state_name ? assignment.wp_state_name : "N.A."
                  }}
                  <br />
                  <b>Can travel upto: </b>
                  {{
                  assignment.wp_distance
                  ? assignment.wp_distance + " miles"
                  : "N.A."
                  }}
                </div>
                <div class="col">
                  <b>Phone: </b>{{
                  assignment.wp_phone
                  ? (assignment.wp_phone | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                  <br />
                  <b>Specialty: </b>
                  {{
                  assignment.wp_speciality ? assignment.wp_speciality : "N.A."
                  }}
                  <br />
                  <b>Country: </b>
                  {{
                  assignment.wp_country_name
                  ? assignment.wp_country_name
                  : "N.A."
                  }}
                  <br />
                  <b>City: </b>
                  {{
                  assignment.wp_city_name ? assignment.wp_city_name : "N.A."
                  }}
                  <br />
                  <b>Zip: </b>
                  {{ assignment.wp_zip ? assignment.wp_zip : "N.A." }} <br />
                  <b>Type: </b>
                  {{
                  assignment.wp_type === 1
                  ? "Business"
                  : assignment.wp_type == 2
                  ? "Customer"
                  : "Partner"
                  }}
                </div>
              </div>
            </div>
            <!--Preapproval lead Info-->
            <div class="b mb-1 p-2 rounded note-item" *ngIf="assignment.action_type == 'preapproval_business_leads'">
              <p class="text-bold mb-2 h4">Pre-Approval leads Information</p>
              <div class="row">
                <div class="col">
                  <b>Application ID: </b>
                  <a [routerLink]="
                      '/app/patients/customers-leads/details/' +
                      assignment.leads_application_id
                    ">
                    {{ assignment.leads_application_id }}
                  </a>
                  <br />
                  <b>Name: </b>
                  {{ assignment.leads_customer_first_name }}
                  {{ assignment.leads_customer_last_name }}
                </div>
                <div class="col">
                  <b>Email: </b>
                  {{
                  assignment.leads_customer_email
                  ? assignment.leads_customer_email
                  : "N.A."
                  }}<br />
                  <b>Mobile: </b>{{
                  assignment.leads_customer_mobile
                  ? (assignment.leads_customer_mobile | countryPhone : assignment.country_id)
                  : "N.A."
                  }}
                </div>
              </div>
            </div>

            <!--Admin Info-->
            <div class="b mb-1 p-2 rounded note-item">
              <div class="row">
                <div class="col-6">
                  <div class="d-flex align-items-center">
                    <i tappable class="fa fa-sign-in me-2" [tooltip]="'Incoming Call'"
                      *ngIf="assignment.contact_type == 1"></i>
                    <i tappable class="fa fa-sign-out me-2" [tooltip]="'Outgoing Call'"
                      *ngIf="assignment.contact_type == 2"></i>
                    <i tappable class="fa fa-envelope me-2" [tooltip]="'Email'"
                      *ngIf="assignment.contact_type == 3"></i>
                    <i tappable class="fa fa-envelope me-2" [tooltip]="'Text'" *ngIf="assignment.contact_type == 4"></i>
                    <i tappable class="fa fa-envelope me-2" [tooltip]="'Chat'" *ngIf="assignment.contact_type == 5"></i>
                    <i tappable class="fa fa-envelope me-2" [tooltip]="'Verification Call'"
                      *ngIf="assignment.contact_type == 6"></i>
                    <i tappable class="fa fa-envelope me-2" [tooltip]="'Potential Business'"
                      *ngIf="assignment.contact_type == 7"></i>
                    <i tappable class="fa fa-envelope me-2" [tooltip]="'Validation'"
                      *ngIf="assignment.contact_type == 8"></i>
                    <p class="m-0">
                      <strong class="admin_name">{{
                        assignment.admin_name
                        }}</strong>
                      {{ assignment.date_added | date : "medium" : timezone }}
                      ({{ timezoneName }})
                      <span *ngIf="
                          assignment.action_type != 'wordpress_support_query' && assignment.action_type != 'bankruptcy'
                        ">
                        <span *ngIf="assignment.priority <= 1" class="ms-2 badge bg-info">low priority</span>
                        <span *ngIf="assignment.priority == 2" class="ms-2 badge bg-warning">medium priority</span>
                        <span *ngIf="assignment.priority == 3" class="ms-2 badge bg-danger">high priority</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="col-6 text-end" *ngIf="
                    assignment.action_type != 'wordpress_support_query' &&
                    assignment.action_type != 'business_call_request' &&
                    !(assignment && assignment.cus_dispute_id > 0)
                  ">
                  <b>Result of Call: </b>
                  <span *ngIf="assignment.contact_result == 1">Voicemail</span>
                  <span *ngIf="assignment.contact_result == 2">No Answer</span>
                  <span *ngIf="assignment.contact_result == 3">Voicemail Full</span>
                  <span *ngIf="assignment.contact_result == 4">Answered</span>
                </div>
              </div>

              <div class="speech-bubble">
                <p style="margin-bottom: 0">
                  <span *ngIf="
                      assignment &&
                      assignment.callback_reason &&
                      assignment.callback_reason != null
                    " class="pr-1"><strong>Reason:</strong>
                    {{ assignment.callback_reason }}</span>
                </p>
                <p>
                  <span class="show-enter"><strong>Message/Note:</strong>
                    <span [innerHtml]="
                        (assignment.wp_message || assignment.note)?.replaceAll(
                          '\n',
                          '<br/>'
                        )
                      "></span>
                    <div *ngIf="assignment && assignment.wp_src_url">
                      {{ assignment.wp_src_url }}
                    </div>
                  </span>
                </p>
              </div>
              <div *ngIf="
                  assignment &&
                  assignment.req_docs?.length > 0
                " class="d-flex align-items-center">
                <a tappable [href]="doc.file_url" target="_blank"
                  class="d-flex align-items-center justify-content-center m-1 border bg-dark"
                  *ngFor="let doc of assignment.req_docs" style="height: 80px; width: 80px">
                  <img [src]="doc.thumb_url" alt="" class="img-fluid" />
                </a>
              </div>
              <p>
                <i tappable class="fa fa-user me-2" [tooltip]="'Assigned to'"></i><b>{{
                  assignment.assigned_admin_name
                  ? assignment.assigned_admin_name
                  : "Not Assigned Yet"
                  }}</b>
                |
                <i tappable class="fa fa-calendar me-2" [tooltip]="'Follow up'"></i><b>{{
                  assignment.followup_date
                  ? (assignment.followup_date
                  | date : "MM/dd/yyyy hh:mm:ss aaa" : timezone)
                  : "Not Available"
                  }}</b>
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-12">
      <div class="card b">
        <div class="card-header bg-gray-lighter text-bold">Actions</div>
        <div class="list-group">
          <button href="javascript:void(0)" class="list-group-item list-group-item-action text-primary"
            (click)="location.back()">
            <i class="fa fa-angle-left"></i> Back
          </button>
          <button href="javascript:void(0)" class="list-group-item list-group-item-action"
            (click)="setStatusForm(); changeStatusModal(); setFollowDate()"
            [disabled]="assignment && assignment.is_deleted == 1">
            <i class="fa fa-pencil"></i> Change Status / Reassign
          </button>
          <!-- <button href="javascript:void(0)" class="list-group-item  list-group-item-action" (click)="reassignModal.show()"
          [disabled]="assignment && assignment.is_deleted == 1">
          <i class="fa fa-edit"></i> Reassign Request
        </button> -->
        <button href="javascript:void(0)" class="list-group-item  list-group-item-action" (click)="addNoteModal()"
          [disabled]="assignment && assignment.is_deleted == 1">
          <i class="fa fa-plus"></i> Add Notes
        </button>
        <span >
          <button  class="list-group-item  list-group-item-action"  *ngIf="assignment.request_type == 'doctor_dispute_documents'" 
          (click)="viewDocument()"        >
            <i class="fa fa-eye"></i> View Documents
          </button>
        </span>
        <!-- <span *ngIf="assignment">
          <button href="javascript:void(0)" class="list-group-item  list-group-item-action"
            [routerLink]="'/app/users/assignments/inquiry_people/'+assignment.req_id"
            *ngIf="assignment.wp_query_id && assignment.wp_query_id > 0 && assignment.wp_type !== 1">
            <i class="fa fa-search"></i> Related Businesses/Leads
          </button>
        </span> -->
          <span *ngIf="assignment && !_shared.routerAuth.restricted_buttons.edit">
            <button href="javascript:void(0)" class="list-group-item list-group-item-action"
              (click)="updateInformationInquiryModal()" *ngIf="
                assignment &&
                assignment.wp_query_id &&
                assignment.wp_query_id > 0 &&
                assignment.wp_type !== 1
              " [disabled]="assignment && assignment.is_deleted == 1">
              <i class="fa fa-pencil-square-o"></i> Edit Details
            </button>
          </span>
          <span *ngIf="assignment.action_type == 'wrongly_formatted_file_uploaded'">
            <button href="javascript:void(0)" class="list-group-item list-group-item-action"
              [routerLink]="['/app/debt-recovery/raw-files']"
              [queryParams]="{ doctor_id: assignment.doctor_id, req_id: assignment.req_id }"
              [disabled]="assignment && assignment.is_deleted == 1">
              <i class="fa fa-upload"></i> Upload AR Formatted File
            </button>
          </span>
           <button  class="list-group-item  list-group-item-action"  *ngIf="assignment && assignment?.business_docs?.length" 
          (click)="businessDocument()"        >
            <i class="fa fa-eye"></i> View Business Documents
          </button>

        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header bg-gray-lighter text-bold">Notes</div>
        <div class="card-body">
          <div *ngIf="notes?.length; else empty">
            <div class="border rounded mb-2 p-2" *ngFor="let note of notes">
              <p *ngIf="note.doctor_id">
                <b>{{ note.note_practice_name || note.note_doctor_name }}</b> -
                {{ note.date_added | date : "medium" : timezone }} ({{
                timezoneName
                }})
              </p>
              <p *ngIf="!note.doctor_id && note.is_cron == 0">
                <b>{{ note.admin_name }}</b> -
                {{ note.date_added | date : "medium" : timezone }} ({{
                timezoneName
                }})
              </p>
              <p *ngIf="!note.doctor_id && note.is_cron == 1">
                <b>System</b> -
                {{ note.date_added | date : "medium" : timezone }} ({{
                timezoneName
                }})
              </p>
              <p class="speech-bubble show-enter">
                <ng-container *ngIf="note.action">
                  <span><b>Action: &nbsp;</b>{{ note.is_approved == 2 ? (note.action === 'Written off' ? 'Write off' : note.action === 'Charged off' ? 'Charge off' : note.action === 'Canceled' ? 'Cancellation' : note.action) : note.action }} {{ note.is_approved == 2 ? 'Reject' : note.is_approved == 1 ? 'Approved' : '' }}</span><br />
                </ng-container>
                <ng-container *ngIf="note.contact_type">
                  <span><b>Type of Contact: &nbsp; </b>{{ note.contact_name }}</span><br />
                </ng-container>
                <ng-container *ngIf="note.contact_result">
                  <span><b>Result of Contact: &nbsp; </b>{{ note.result_value }}</span><br />
                </ng-container>
                <ng-container *ngIf="note.followup_date">
                  <span><b>Follow up Date:</b> &nbsp;
                    {{
                    note.followup_date | date : "MM/dd/yyyy" : timezone
                    }}</span><br />
                </ng-container>
                <b>Note: &nbsp;</b>
                <span [innerHTML]="note.note?.replaceAll('\n', '<br/>')"></span>
              </p>
              <div *ngIf="note && note.note_docs?.length > 0" class="d-flex align-items-center">
                <a tappable [href]="doc.file_url" target="_blank"
                  class="d-flex align-items-center justify-content-center m-1 border bg-dark"
                  *ngFor="let doc of note.note_docs" style="height: 80px; width: 80px">
                  <img [src]="doc?.thumb_url && (doc.thumb_url.includes('.png') || doc.thumb_url.includes('.jpg') || doc.thumb_url.includes('.jpeg') || doc.thumb_url.includes('.svg')) ? doc.thumb_url : 'assets/images/icons/paperclip.png' " alt="" class="img-fluid" />
                </a>
              </div>
              <div>
                <span *ngIf="note.reassigned_id && note.change_status != 1">
                  <i class="fa fa-user" tooltip="Reassigned to"></i>
                  {{ note.reassigned_admin_name }}
                </span>
                <span *ngIf="note.change_status == 1" class="badge bg-dark"><i class="fa fa-close"></i> Closed</span>
                <span *ngIf="note.change_status == 2" class="badge bg-primary"><i class="fa fa-repeat"></i> Re-Opened{{
                  note.followup_date
                  ? " : " +
                  (note.followup_date
                  | date : "MM/dd/yyyy hh:mm:ss aaa" : timezone)
                  : ""
                  }}</span>
                <span *ngIf="note.change_status == 3" class="badge bg-info"><i class="fa fa-calendar"></i> Followup{{
                  note.followup_date
                  ? " : " +
                  (note.followup_date
                  | date : "MM/dd/yyyy hh:mm:ss aaa" : timezone)
                  : "Not Available"
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="
      assignment &&
      assignment.wp_query_id &&
      assignment.wp_query_id > 0 &&
      assignment.wp_type !== 1 &&
      inquiry_email_sent_records?.length
    ">
    <div class="col-12">
      <div class="card">
        <div class="card-header bg-gray-lighter text-bold">
          Email history for inquiry:
        </div>
        <div class="table-responsive search_doctor_table">
          <table class="table">
            <thead>
              <tr>
                <th>S No.</th>
                <th>Business Owner Name</th>
                <th>Business Owner email</th>
                <th>No Of Emails Sent</th>
                <th>Sender Admin</th>
                <th>Last Sent Date And Time</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of inquiry_email_sent_records; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  {{ record.full_name ? record.full_name : "-" }}
                </td>
                <td>
                  {{
                  record.lead_doctor_email ? record.lead_doctor_email : "-"
                  }}
                </td>
                <td>
                  {{
                  record.number_of_email_sent
                  ? record.number_of_email_sent
                  : "-"
                  }}
                </td>
                <td>
                  {{
                  record.admin_email
                  ? record.admin_name + " (" + record.admin_email + ")"
                  : "-"
                  }}
                </td>
                <td>
                  {{
                  record.date_created
                  ? (record.date_created
                  | date : "MMM dd, y, h:mm a" : timezone)
                  : "-"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- <div class="row border-top pt-2 align-items-center" *ngIf="doctorsList && doctorsList.length">
    <div class="col-md-6 col-sm-12">
      <p class="text-bold">
        Showing {{(1+(resData.pageNumber - 1) * 10)}} to {{(doctorsList.length + (resData.pageNumber - 1) *
            10)}} of {{resData.totalRecords || 'all'}}
      </p>
    </div>
    <div class="col-md-6 col-sm-12">
      <pagination class="pagination-sm float-md-right" [totalItems]="resData.totalRecords" [maxSize]="5"
        [boundaryLinks]="true" [rotate]="false" (pageChanged)="pageChanged($event)" [(ngModel)]="resData.pageNumber">
      </pagination>
    </div>
  </div> -->
  </div>
</div>